@if (showLoader) {
  <collaboration-ui-spinner [overlay]="true"></collaboration-ui-spinner>
}
<div>
  <mat-drawer-container [class.visibility]="isDrawerOpened" class="drawer-container" autosize
    (backdropClick)="backdropClick()">
    <mat-drawer #drawer [(opened)]="isDrawerOpened" autoFocus="false" class="drawer-container-sidenav" mode="over"
      position="end">
      <section class="settings">
        <div class="settings-close">
          <img [src]="'images/close_black.svg' | assetUrl" alt="Close Icon" (click)="backdropClick()"
            (keypress)="backdropClick()" />
          </div>
          <section class="settings-accordion-wrapper">
            <div class="settings-accordion">
              <div [matTooltip]="notificationConfig?.name" class="notifications-header">
                <span>
                  <img alt="settings" [src]="'images/global-connection.png' | assetUrl"
                    class="icon-mr-5" />
                  </span>
                  <h3 class="h3-title">{{notificationConfig?.name}}</h3>
                </div>
                <h6 class="pref-msg">**Set your email preference for Tasks</h6>
                <form [formGroup]="notificationSettingsFg">
                  <div class="settings-accordion-list">
                    @for (field of notificationSettingsFields; track field) {
                      <div class="settings-accordion-list-group">
                        <div class="settings-accordion-list-item">
                          <div class="settings-accordion-list-item-label">
                            {{ field?.label }}
                          </div>
                          <div class="settings-accordion-list-item-toggle">
                            <mat-slide-toggle [formControlName]="field.name">
                            </mat-slide-toggle>
                          </div>
                        </div>
                        <br />
                      </div>
                    }
                  </div>
                </form>

              </div>
              <div class="settings-button-group">
                <div>
                  <button class="settings-button-group-cancel" (click)="backdropClick()">Cancel</button>
                  <button class="settings-button-group-save"
                  (click)="updateNotificationSettings()">Save</button>
                </div>
              </div>
            </section>
          </section>

        </mat-drawer>
      </mat-drawer-container>
    </div>